/**
 * Имя класса, заменяющий ввод конфиденциальной информации на звездочки яндекс веб-визору
 */
export const WEB_VISOR_DISABLE = 'ym-disable-keys';

/**
 * Имя класса, блокирующего показ блока с конфиденциальной информацией яндекс веб-визору
 */
export const WEB_VISOR_HIDE = 'ym-hide-content';
